import type { BoundActions, HookActionsFunction, HookFunction } from 'react-sweet-state';
import { createStore, createHook, createActionsHook } from 'react-sweet-state';

type PageRemovalState = {
	isPageBeingRemoved: boolean;
};

const actions = {
	setIsPageBeingRemoved:
		(isPageBeingRemoved: boolean) =>
		({ setState }: { setState: any }): void => {
			setState({ isPageBeingRemoved });
		},
};

const pageRemovalStore = createStore({
	initialState: {
		isPageBeingRemoved: false,
	} as PageRemovalState,
	actions,
	name: 'pageRemovalState',
});

export const usePageRemovalState: HookFunction<
	PageRemovalState,
	BoundActions<
		PageRemovalState,
		{
			setIsPageBeingRemoved: (
				isPageBeingRemoved: boolean,
			) => ({ setState }: { setState: any }) => void;
		}
	>,
	void
> = createHook(pageRemovalStore);
export const usePageRemovalStateActions: HookActionsFunction<
	BoundActions<
		PageRemovalState,
		{
			setIsPageBeingRemoved: (
				isPageBeingRemoved: boolean,
			) => ({ setState }: { setState: any }) => void;
		}
	>
> = createActionsHook(pageRemovalStore);
